export default __webpack_public_path__ + "static/media/select-dropdown-arrow.4ee30da9.svg";